import { FC, ReactNode } from "react";
import { Flex } from "@otrium/core";
import {
  FilterItemWrapper,
  FilterItemTitle,
  FilterItemInfo,
} from "src/organisms/AlgoliaProductList/MobileFilterView/MobileFilters.styled";
import { ActiveFilters } from "src/organisms/AlgoliaProductList/MobileFilterView/ActiveFilters";
import { MessageDescriptor } from "@lingui/core";
import { useLingui } from "@lingui/react";

const FilterItemText: FC<{
  text: MessageDescriptor;
  icon: ReactNode;
  facet: string;
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  selectedCatSlug?: string[];
}> = ({ text, icon, facet, keepSelectedIgnoreInActive, selectedCatSlug }) => {
  const { _ } = useLingui();
  return (
    <FilterItemWrapper>
      <Flex variant="centered" width={"32px"} height={"32px"} mr={2}>
        {icon}
      </Flex>
      <FilterItemTitle>{_(text)}</FilterItemTitle>
      <FilterItemInfo>
        <ActiveFilters
          facet={facet}
          keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
          selectedCatSlug={selectedCatSlug}
        />
      </FilterItemInfo>
    </FilterItemWrapper>
  );
};

export default FilterItemText;
